import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const pillsContainer = css({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1x',
});

export const pill = css({
  paddingX: '2x',
  paddingY: 'xs',
  borderRadius: '20px',
  fontSize: 'sm',
  fontWeight: '600',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  backgroundColor: 'hpxWhite',
  color: 'hpxBlue600',
  cursor: 'pointer',
  transitionProperty: 'all',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
});

export const pillSelected = css({
  paddingX: '2x',
  paddingY: 'xs',
  borderRadius: '20px',
  fontSize: 'sm',
  fontWeight: '600',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxTeal500',
  backgroundColor: 'hpxTeal500',
  color: 'hpxWhite',
  cursor: 'pointer',
});

export const dropdownLabel = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const dropdown = css({
  width: '100%',
  padding: '1x',
  paddingRight: '4x',
  fontSize: 'sm',
  color: 'hpxBlue600',
  backgroundColor: 'hpxWhite',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  cursor: 'pointer',
  appearance: 'none',
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23212a3b' stroke-width='2' fill='none'/%3E%3C/svg%3E\")",
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
});
